import React from 'react';
import { Link } from 'react-router-dom';

export type RecentSidebarProps = {
  elements: { title: string; id: number | string; link: string }[];
  viewAllLink?: string;
  title: string;
  emptyStateMessage: string;
  className?: string;
};
export default function RecentSidebar({
  elements,
  viewAllLink,
  title,
  emptyStateMessage,
  className,
}: RecentSidebarProps) {
  return (
    <div className={className}>
      <div className="grid grid-cols-1 gap-4">
        <section>
          <div className="rounded-lg bg-white overflow-hidden shadow">
            <div className="p-6">
              <h2 className="text-base font-medium text-gray-900">{title}</h2>
              <div className="flow-root mt-6">
                <ul className="-my-5 divide-y divide-gray-200" data-cy="tests">
                  {elements.length > 0 ? (
                    React.Children.toArray(
                      elements.map((element) => (
                        <li key={element.id} className="py-4">
                          <div className="flex items-center space-x-4">
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate">
                                {element.title}
                              </p>
                            </div>
                            <div>
                              <Link
                                to={element.link}
                                className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                              >
                                View
                              </Link>
                            </div>
                          </div>
                        </li>
                      ))
                    )
                  ) : (
                    <p className="text-sm text-gray-500 truncate">
                      {emptyStateMessage}
                    </p>
                  )}
                </ul>
              </div>
              {elements.length > 0 && viewAllLink && (
                <div className="mt-6">
                  <Link
                    to={viewAllLink}
                    className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  >
                    View all
                  </Link>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
